"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerSpanErrorInstrumentation = registerSpanErrorInstrumentation;

var _debugBuild = require("../debug-build.js");

var _globalError = require("../utils-hoist/instrument/globalError.js");

var _globalUnhandledRejection = require("../utils-hoist/instrument/globalUnhandledRejection.js");

var _logger = require("../utils-hoist/logger.js");

var _spanUtils = require("../utils/spanUtils.js");

var _spanstatus = require("./spanstatus.js");

let errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */

function registerSpanErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  (0, _globalError.addGlobalErrorInstrumentationHandler)(errorCallback);
  (0, _globalUnhandledRejection.addGlobalUnhandledRejectionInstrumentationHandler)(errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */


function errorCallback() {
  const activeSpan = (0, _spanUtils.getActiveSpan)();
  const rootSpan = activeSpan && (0, _spanUtils.getRootSpan)(activeSpan);

  if (rootSpan) {
    const message = 'internal_error';
    _debugBuild.DEBUG_BUILD && _logger.logger.log(`[Tracing] Root span: ${message} -> Global error occurred`);
    rootSpan.setStatus({
      code: _spanstatus.SPAN_STATUS_ERROR,
      message
    });
  }
} // The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour


errorCallback.tag = 'sentry_tracingErrorCallback';